module.exports = __webpack_public_path__ + "8cdc7c1e49fe7de7833ddc1bf0614d63.png";